import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("header .nav li").eq(1).addClass("active");
var swiper = new Swiper(".section1 .mySwiper", {
  direction: 'vertical',
  slidesPerView: 4,
  spaceBetween: 10,
  freeMode: true,
});
var swiper2 = new Swiper(".section1 .mySwiper2", {
  navigation: {
    nextEl: ".section1 .swiper-button-next",
    prevEl: ".section1 .swiper-button-prev",
  }, 
  thumbs: {
    swiper: swiper,
  },
});
$(".right .mySwiper .swiper-slide").click(function () {
  let index = $(this).index();
  swiper2.slideTo(index, 1000, false);
})
$(".swiper-button div").click(function () {
  $(this).addClass("active").siblings().removeClass("active");
})
// 产品属性
$(".material li").eq(0).addClass("active");
$(".quality-box ul").eq(0).addClass("active");
$(".material li").hover(function () {
  let index = $(this).index();
  $(this).addClass("active").siblings().removeClass("active");
  $(".quality-box ul").eq(index).addClass("active").siblings().removeClass("active");
})

//推荐
var recommend = new Swiper(".recommend .mySwiper", {
  slidesPerView: 5,
  navigation: {
    nextEl: ".recommend .swiper-button-next",
    prevEl: ".recommend .swiper-button-prev",
  },
breakpoints: {
  320: { //当屏幕宽度大于等于320
  slidesPerView: 2,
  spaceBetween: 10,
  },
  768: { //当屏幕宽度大于等于768 
    slidesPerView: 3,
      spaceBetween: 15,
  },
  1280: { //当屏幕宽度大于等于1280
      slidesPerView: 5,
      spaceBetween: 16,
  }
},
});